import { call, put, select, take } from 'redux-saga/effects';

import * as Constants from '../../../constants';
import { ApiActions } from '../../../constants/ApiActions';
import { getInDomain } from '../../../domains/externalUtils';
import { taskManagerSpawnFactory } from '../../../sagas/Helpers/SpawnedTaskManager';
import { putAndWait } from '../../../sagas/TaskManager';
import Logger from '../../../tools/Logger';
import { USE_CASE_TASK_MANAGER_GROUP } from '../constants';

const log = Logger.child({
  component: 'mediator/useCases/playRewardsAd/helpers',
});
const spawn = taskManagerSpawnFactory(USE_CASE_TASK_MANAGER_GROUP);

function* showCompanionAfterPremiumAccessEnds(companion) {
  let hasPremiumAccessReward = true;

  while (hasPremiumAccessReward) {
    const loginSuccessAction = yield take([
      ApiActions.LOGIN_SUCCESS,
      ApiActions.DEVICE_LOGIN_SUCCESS,
    ]);
    const newRewards = getInDomain('rewards.utils.getActiveVxRewardsFromLoginAction')(
      loginSuccessAction.response,
    );
    const isPremiumAccessEnded = !getInDomain('rewards.utils.checkHasPremiumAccess')(newRewards);
    const currentStationId = yield select(getInDomain('playback.utils.getCurrentStationId'));
    const stationIsAdvertiser = yield select(
      getInDomain('playback.utils.getStationIsAdvertiser'),
      currentStationId,
    );
    log.info(
      {
        loginSuccessAction,
        newRewards,
        isPremiumAccessEnded,
        currentStationId,
        stationIsAdvertiser,
      },
      'showCompanionAfterPremiumAccessEnds',
    );

    if (isPremiumAccessEnded && !stationIsAdvertiser) {
      hasPremiumAccessReward = false;
      yield take(Constants.Listener.ListenerActions.LISTENER_AUTHENTICATED); // wait for domains to recalculate
      yield call(putAndWait, getInDomain('videoAds.actions.showCompanionAd')(companion));
    } else if (isPremiumAccessEnded && stationIsAdvertiser) {
      return;
    }
  }
}

function* companionHandler(event) {
  log.info('companionHandler');
  yield spawn(showCompanionAfterPremiumAccessEnds, event.data.companion);
}

export function getPremiumAccessEventChannelHandlers() {
  return {
    [Constants.Ads.Video.Events.COMPANION]: companionHandler,
  };
}

export function* closeRewardsCoachmark() {
  getInDomain('rewards.utils.closeCoachmark')();
  yield put(getInDomain('rewards.actions.clearOpenCoachmark'));
}
